import generateUtilityClass from '@mui/utils/generateUtilityClass';
import generateUtilityClasses from '@mui/utils/generateUtilityClasses';
export function getMultiSectionDigitalClockSectionUtilityClass(slot) {
  return generateUtilityClass('MuiMultiSectionDigitalClockSection', slot);
}
export const multiSectionDigitalClockSectionClasses = generateUtilityClasses('MuiMultiSectionDigitalClockSection', ['root', 'item']);